import React from 'react';
import './GradientButton.css';
import { useTheme } from '@springbig/shared';

type OpenAppButtonButtonProps = {
    appScheme: string;
    appStoreURL: string;
    playStoreURL: string;
}

export const OpenAppButton = (props: OpenAppButtonButtonProps) => {

    const {
        radius_sm,
        menu_background_secondary,
    } = useTheme();

    const isAppInstalled = () => {

        const start = Date.now();
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        document.body.appendChild(iframe);

        // Try to open the app
        iframe.src = props.appScheme;

        // If the app is not installed, redirect to the app store after a timeout
        setTimeout(() => {

            const end = Date.now();
            if (end - start < 1500) {
                if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                    window.location.href = props.appStoreURL;
                }
                else if (/Android/i.test(navigator.userAgent)) {
                    window.location.href = props.playStoreURL;
                }
            }

            document.body.removeChild(iframe);
        }, 1000);
    };

    return (
        <button
            style={{
                background: menu_background_secondary,
                padding: '2px 10px',
                borderRadius: radius_sm,
            }}
            className="gradient-button"
            onClick={() => isAppInstalled()}
        >
            <span>open app</span>
        </button>
    );
};

